import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-200 px-4 py-8 sm:py-12" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = { class: "text-center mb-6 sm:mb-8" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-base sm:text-lg font-medium" }, " Sistema de Agendamentos ", -1)
const _hoisted_6 = { class: "bg-white rounded-xl sm:rounded-2xl shadow-lg p-6 sm:p-8 border border-gray-200" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "pt-3 sm:pt-4 md:px-2" }
const _hoisted_12 = { class: "flex items-center justify-center gap-2" }
const _hoisted_13 = { class: "text-center text-sm" }
const _hoisted_14 = { class: "text-center text-xs text-gray-400 mt-6" }

import { ref, reactive } from "vue";
import { branding } from "@/branding";
import { getThemeColor } from "@/branding";
import router from "@/router";
import store from "@/store";
import SolicitarAcesso from "@/components/auth/SolicitarAcesso.vue";
import EsqueciSenha from "@/components/auth/EsqueciSenha.vue";
import InputText from "@/components/inputs/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const solicitarAcessoShow = ref(false);
const esqueciSenhaShow = ref(false);
const theme = getThemeColor();
const logoUrl = `${process.env.BASE_URL}img/moinho-globo-logo.png`;

const userInfo = reactive({
  usuario: "",
  password: "",
  cia_ukey: "1",
  device_name: "SaerpAgendamento",
  usuario_externo: "1",
});
const passwordView = ref(false);

const contemApenasNumeros = (str: string) => {
  return /^[0-9]+$/.test(str);

}
const login = async (e: Event) => {
  e.preventDefault();

  const usuario = userInfo.usuario.replaceAll('.', '').replaceAll('/', '').replaceAll('\\', '').replaceAll('/', '').replaceAll('-', '');

  const data = {
    ...userInfo,
    usuario: contemApenasNumeros(usuario) ? usuario : userInfo.usuario, // SE FOR CNPJ/CPF TIRA A PONTUACAO, SE NAO CONTINUA
  };

  let resp = await store.dispatch("login", data);
  if (resp.status == 200) {
    store.commit("SET_ACESSOS", {
      usuario_externo: resp.data.user.usuario_externo == "1",
      usuario_trigo_produtor: resp.data.user.parceiro?.tipo_parceiro == "10",
      usuario_local_recebimento_graos:
        resp.data.user.setor_ukey == "4e1db01f7c532fcb5de4",
      usuario_recepcao_materia_prima:
        resp.data.user.parceiro?.dadosComplementares?.fornecedor_de_materia_prima == 1,
    });
    if (resp.data?.user?.parceiro?.tipo_parceiro == "10") {
      router.push("/motoristas-placas");
      return;
    }
    router.push("/");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: logoUrl,
          alt: _unref(branding).brandName,
          class: "mx-auto h-16 sm:h-20 w-auto mb-4"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          onSubmit: login,
          class: "space-y-5 sm:space-y-6"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(InputText, {
              name: "usuario",
              label: "Usuário",
              tclass: "w-full",
              modelValue: userInfo.usuario,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInfo.usuario) = $event)),
              placeholder: "Digite seu usuário"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(InputText, {
                name: "password",
                label: "Senha",
                type: passwordView.value ? 'text' : 'password',
                tclass: "w-full",
                modelValue: userInfo.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInfo.password) = $event)),
                placeholder: "Digite sua senha"
              }, null, 8, ["type", "modelValue"]),
              _createElementVNode("button", {
                type: "button",
                class: "absolute right-6 top-11 text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none z-10 cursor-pointer",
                "aria-label": passwordView.value ? 'Ocultar senha' : 'Mostrar senha',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordView.value = !passwordView.value))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: passwordView.value ? 'eye' : 'eye-slash',
                  class: "text-lg"
                }, null, 8, ["icon"])
              ], 8, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_t_button, {
              type: "submit",
              class: _normalizeClass(["w-full py-3 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-4", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900 focus:ring-${_unref(theme)}-300`])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(" Entrar "),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "sign-in-alt",
                    class: "text-base"
                  })
                ])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-500 underline hover:text-gray-700 transition-colors duration-150 focus:outline-none",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (esqueciSenhaShow.value = true))
            }, " Esqueci a senha ")
          ])
        ], 32)
      ]),
      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(branding).pageTitle), 1)
    ]),
    _createVNode(SolicitarAcesso, {
      show: solicitarAcessoShow.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (solicitarAcessoShow.value = false))
    }, null, 8, ["show"]),
    _createVNode(EsqueciSenha, {
      show: esqueciSenhaShow.value,
      "usuario-inicial": userInfo.usuario,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (esqueciSenhaShow.value = false))
    }, null, 8, ["show", "usuario-inicial"])
  ]))
}
}

})